/* AIOS-CARD-CART-ORANGE — fill the collection-card corner cart icon with the
   same tan (#deb891) the header bag uses when its product is in the cart, and
   empty it again when the product is removed. Product-level match: any variant
   of the product in the cart => that card's icon fills. Robust to every way the
   cart can change (quick-add, drawer remove, /cart page remove, clear). */
(function(){
  if (window.__aiosCardCartOrange) return;
  window.__aiosCardCartOrange = 1;

  function apply(ids){
    var btns = document.querySelectorAll('.aios-cart-cta[data-aios-product-id]');
    for (var i = 0; i < btns.length; i++){
      var pid = btns[i].getAttribute('data-aios-product-id');
      btns[i].classList.toggle('is-in-cart', ids.indexOf(pid) !== -1);
    }
  }

  var busy = false, queued = false;
  function sync(){
    if (busy){ queued = true; return; }
    busy = true;
    fetch('/cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin'})
      .then(function(r){ return r && r.ok ? r.json() : null; })
      .then(function(cart){
        if (cart && cart.items){
          apply(cart.items.map(function(it){ return String(it.product_id); }));
        }
      })
      .catch(function(){})
      .then(function(){
        busy = false;
        if (queued){ queued = false; sync(); }
      });
  }

  var t = null;
  function syncSoon(){ clearTimeout(t); t = setTimeout(sync, 250); }

  // initial paint
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  // Dawn's own cart-change signal (fires on add + drawer/cart removes)
  function hookPubSub(){
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate){
        subscribe(PUB_SUB_EVENTS.cartUpdate, syncSoon);
        return true;
      }
    } catch(e){}
    return false;
  }
  if (!hookPubSub()){
    document.addEventListener('DOMContentLoaded', hookPubSub);
    window.addEventListener('load', hookPubSub);
  }

  // catch-all: any cart mutation request, however it was triggered
  var of = window.fetch;
  if (of && !of.__aiosCartOrangeWrap){
    window.fetch = function(){
      var u = arguments[0];
      u = (u && u.url) ? u.url : ('' + u);
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(u)){
        try { p.then(function(){ syncSoon(); }).catch(function(){}); } catch(e){}
      }
      return p;
    };
    window.fetch.__aiosCartOrangeWrap = 1;
  }

  document.addEventListener('cart:refresh', syncSoon);
  window.addEventListener('pageshow', syncSoon);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) syncSoon(); });
})();
